// Retorna a mesma string com sua inicial maiúscula
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}